import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export const getSuggestions = (payload) => {
  return MessageBroker.send(RequestUrls.suggestions, payload);
};

export const getQletLookup = (payload) => {
  return MessageBroker.send(RequestUrls.qletlookup, payload);
};
